import AlternateBoxes from 'components/alternate-boxes/alternate-boxes.js'
import AboutBox from 'components/about-box/about-box.js'
import AboutMap from 'components/about-map/about-map.js'
import ContactsContent from 'components/contacts-content/contacts-content.js'
import DownloadBox from 'components/download-box/download-box.js'
import FeatureSlider from 'components/feature-slider/feature-slider.js'
import FloatBanner from 'components/float-banner/float-banner.js'
import Footer from 'components/footer/footer.js'
import FullSlider from 'components/full-slider/full-slider.js'
import GallerySlider from 'components/gallery-slider/gallery-slider.js'
import InfoBox from 'components/info-box/info-box.js'
import InfoCertifications from 'components/info-certifications/info-certifications.js'
import InfoImages from 'components/info-images/info-images.js'
import MobileNav from 'components/mobile-nav/mobile-nav.js'
import ModalForm from 'components/modal-form/modal-form.js'
import Numbers from 'components/numbers/numbers.js'
import ProductTypesList from 'components/product-types-list/product-types-list.js'
import PageContent from 'components/page-content/page-content.js'
import PostContent from 'components/post-content/post-content.js'
import PostsList from 'components/posts-list/posts-list.js'
import PostsSlider from 'components/posts-slider/posts-slider.js'
import Sidebar_Content from 'components/sidebar-content/sidebar-content.js'
import SocialBar from 'components/social-bar/social-bar.js'
import TimelineSlider from 'components/timeline-slider/timeline-slider.js'
import Top from 'components/top/top.js'
import TopPage from 'components/top-page/top-page.js'
import VerticalBoxes from 'components/vertical-boxes/vertical-boxes.js'

export function importComponent (name) {
    const components = {
        'about-box': AboutBox,
        'alternate-boxes': AlternateBoxes,
        'about-map': AboutMap,
        'contacts-content': ContactsContent,
        'download-box': DownloadBox,
        'feature-slider' : FeatureSlider,
        'float-banner' : FloatBanner,
        'footer' : Footer,
        'full-slider' : FullSlider,
        'gallery-slider' : GallerySlider,
        'info-box': InfoBox,
        'mobile-nav': MobileNav,
        'modal-form': ModalForm,
        'numbers': Numbers,
        'product-types-list': ProductTypesList,
        'posts-slider': PostsSlider,
        'social-bar': SocialBar,
        'timeline-slider': TimelineSlider,
        'top' : Top,
        'vertical-boxes' : VerticalBoxes
    }

    return components[name] ? Promise.resolve(components[name]) : Promise.reject('no component found')
}


// WEBPACK FOOTER //
// ./app/theme/components/index.js